import { useSelector } from 'react-redux';

import { tcrBrandSelector } from '@/redux/app/selectors/tcr';
import { orgTrialSurveyNumberTypeSelector } from '@/redux/app/selectors/organization';
import type { TcrBrand } from '@/types/tcr';

export type TrialNextStep = 'a2p' | 'upgrade';

// Where every trial upgrade prompt points: A2P until it's submitted (toll-free trials skip it), then upgrade. Mirrors Account#trial_next_step.
export const trialNextStep = (brandStatus: TcrBrand['status'] | undefined, prefersTfn: boolean): TrialNextStep => (
  prefersTfn || brandStatus === 'REQUEST_PENDING' || brandStatus === 'ACTIVE' ? 'upgrade' : 'a2p'
);

export const useTrialNextStep = () => {
  const brand = useSelector(tcrBrandSelector);
  const prefersTfn = useSelector(orgTrialSurveyNumberTypeSelector) === 'tfn';
  return trialNextStep(brand?.status, prefersTfn);
};

export const trialStepPath = (subdomain: string, step: TrialNextStep) => (
  step === 'a2p' ? `/accounts/${subdomain}/tcr/first_submission` : `/accounts/${subdomain}/billing_v2/upgrade`
);
